var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestaurant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 38.4 45",
    style: {
      enableBackground: "new 0 0 38.4 45"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#827F83;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.4,0c-5,0-9,5-9,10.6c0,3.4,1.6,6.4,3.6,8.3c1.7,1.6,2.8,2.9,3,5.7v18.1c0,1.3,1,2.3,2.3,2.3h0.3 c1.3,0,2.3-1,2.3-2.3V24.6c0.2-2.8,1.3-4,3-5.7c2-1.9,3.6-4.9,3.6-8.3C38.4,5,34.3,0,29.4,0L29.4,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.3,2.2v9.6c0,0.6-0.5,1.1-1.1,1.1h-0.3c-0.6,0-1.1-0.5-1.1-1.1V2.1c0-1.6-1.1-2.1-2.1-2.1S6.6,0.5,6.6,2.1 v9.7c0,0.6-0.5,1.1-1.1,1.1H5.1c-0.6,0-1.1-0.5-1.1-1.1V2.2c0-2.8-4-2.7-4,0v9.2c0,5.1,1.2,6.4,3.2,8c1.6,1.3,3,2,3,5.2v18.1 c0,1.3,1,2.3,2.3,2.3h0.3c1.3,0,2.3-1,2.3-2.3V24.6c0-3.2,1.4-3.9,3-5.2c2-1.6,3.2-2.9,3.2-8V2.2C17.3-0.6,13.3-0.7,13.3,2.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurant);
export default __webpack_public_path__ + "static/media/restaurant.fe62af8704b4bc5e3b871ee2e299fa29.svg";
export { ForwardRef as ReactComponent };